import { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Toaster, toast} from 'react-hot-toast';
import { GETCATEGORIESLIST, GETHOLIDAYDAYS, ADDHOLIDAYDAYS,DELETEHOLIDAYDAYS,UPDATEHOLIDAYDAYS} from "../../../api/apiConfig";
import { apiGet, apiPost } from "../../../utils";
import { Button, Divider, Grid, IconButton, InputAdornment, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { FaBackspace, FaCalendar,FaEdit, FaPlaneDeparture } from "react-icons/fa";
import moment from "moment";
import { BiEdit, BiPlus, BiSearch, BiTrash } from "react-icons/bi";
import { useMediaQuery } from "react-responsive";
import { AnalyticsService } from "../../../utils/Analytics";
import Modal from "react-responsive-modal";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import { Spinner } from "../../atoms";


const HolidayDays = ({ handleSettingSwitch }) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [categoryList, setCategoryList] = useState([]);
  const [holidayDays, setHolidayDays] = useState([]);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [searchItem, setSearchItem] = useState('');
  const [_holiday, set_holiday] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const { register, handleSubmit, formState: { errors } } = useForm();

  useEffect(() => {
    async function populateCategories() { 
      const res = await apiGet(GETCATEGORIESLIST);
      if(res) {
        const { data } = res;
        setCategoryList(data);
      }
    }
    populateCategories();
    populateHolidayDays();
  }, []);

  async function populateHolidayDays() { 
    const res = await apiGet(GETHOLIDAYDAYS);
    if(res) {
      
      const { data } = res;
    
      setHolidayDays(data);
    }
  }
  function canAddHoliday(newHoliday, holidayList) {
    const { startdate: newStartDate, duration: newDuration } = newHoliday;

  if (holidayList.length === 0) {
    return true;
  }

  for (const holiday of holidayList) {
    const { startDate, duration } = holiday;

    
    const existingStartDate = moment(startDate, 'YYYY-MM-DD').toDate();
    const existingEndDate = moment(existingStartDate).add(duration, 'days').toDate();

    
    const newStartDateFormatted = moment(newStartDate, 'DD/MM/YYYY').toDate();
    const newEndDate = moment(newStartDateFormatted).add(newDuration, 'days').toDate();
     console.log("--", existingEndDate, "--", existingStartDate, "--", newStartDateFormatted, "--", newEndDate);
    // Check for overlapping date ranges
    if (
      (newStartDateFormatted >= existingStartDate && newStartDateFormatted < existingEndDate) ||
      (newEndDate > existingStartDate && newEndDate <= existingEndDate) ||
      (newStartDateFormatted <= existingStartDate && newEndDate >= existingEndDate)
    ) {
      return false; 
    }
  }

  return true; 
  }

  function view(){
    const edit=(d)=>{
      set_holiday(d);
      setOpen2(true);
     
    }
    return (
        <div style={{marginTop:'50px'}}>
          <Stack style={{zIndex:'0',background:'white',position:'relative'}} direction={'row'} spacing={2} justifyContent="space-between" className=' space-bottom space-top'>
              
            <TextField 
              size="small"
              type={"search"}
              
                InputProps={{ startAdornment:(
                <InputAdornment position="start">
                  <BiSearch sx={{color: "#8D0C1"}}/>
                </InputAdornment>
              )}} onChange={(data)=> setSearchItem(data.target.value) }    placeholder={'Search by Holiday Name'} />
              <div>
                  {/* <Button  className="space-right2"
                variant="outlined" startIcon={<BiUpload sx={{color: "#1d9649"}}/>}>Upload Merchants</Button> */}
                <Button startIcon={!isTabletOrMobile &&<BiPlus/>} onClick={() => setOpen1(true)} variant="contained">{isTabletOrMobile?'New Holiday Days':'Add New Holiday Days'}</Button>
                
              </div>
          </Stack>

         {holidayDays.length>0 && <Paper>
              <TableContainer >
                <Table  >
                <TableHead className='tableHead' >
                  <TableRow>
                    <TableCell><span className=' bold'>Name</span></TableCell>
                    <TableCell><span className=' bold'>Period</span></TableCell>
                    <TableCell><span className=' bold'>Start Date</span></TableCell>
                    <TableCell style={{width:'15%'}}><span className=' bold'>Actions</span></TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                    {holidayDays?.filter(x=>x.name?.toLowerCase().includes(searchItem?.toLowerCase())).map((data,index)=>{
                      return(
                        <TableRow key={index} className={[_holiday.id==data.id && "selected hover grey2",'click'].join(' ')} onClick={()=>set_holiday(data)}>
                          <TableCell>
                            <Stack direction={"row"} spacing={1} alignItems="center" >
                              <FaPlaneDeparture/>
                              <span>{data.name}</span>
                            </Stack>
                          </TableCell>
                          <TableCell><span>{data.duration+'days'}</span></TableCell>
                          <TableCell><span>{moment(data.startDate).format('Do MMMM')}</span></TableCell>
                         <TableCell>
                            <Stack direction="row"
                              divider={<Divider orientation="vertical" flexItem />}
                            >
                              <IconButton onClick={()=>edit(data)}> <BiEdit fontSize='' /></IconButton>
                              <IconButton onClick={()=>{set_holiday(data);setOpen3(true)}}> <BiTrash fontSize='' /></IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
              </Table>
              </TableContainer>
            </Paper>}
            {AddHolidayDays()}
            {EditHolidayDays()}
            {DeleteHolidayDays()}
        </div>
    )
  }

function details(){
    
const DispatchTimePicker = ({days}) => {
  let needStrike=false
  const holiday=parseInt(days)+ parseInt("0"+_holiday?.duration);
  if(holiday>days) needStrike=true
  return (
    <div className="dispatch-time-picker">
      {[1,2,3,4,5,6,7,8,9,10].map(d=>{
        return (
          (needStrike &&days==d)?
           <button  className="btn-picker2" 
        aria-selected={(days== d || holiday==d) ? "true" : "false"}><span style={{textDecoration:needStrike &&days==d && 'line-through'}}>{d}</span></button>
        :
        <button  className="btn-picker" 
        aria-selected={(days== d || holiday==d) ? "true" : "false"}><span style={{textDecoration:needStrike &&days==d && 'line-through'}}>{d}</span></button>

        )
      })}
      
     
    </div>    
  )
}

    return (
      <div>
        <div className="description mt-1 space-top">
          <p className="sm" style={{width:'95%'}}>
            These dispatch time will be displayed to the customer on each product page during the holiday period.
            This is shown to the customer before they place an order, to set  their expectations.
          </p>
          <div className="example">
            {/* <div className="title-container">
              <span className="fs-5">Example Product: </span>
              <span className="fs-5 fw-bold">Cricket Bat</span>
            </div>  */}
            <div className="d-flex flex-column w-100 mb-3 mt-3"> 
              <div className="d-flex justify-content-between w-100 center ">
                  <span className="value sm">(You manage)</span>
                  <div></div>
                  <span className="value sm">(You manage)</span>
                  <div></div>
                  <span className="value">(The Cricket Store manages)</span>
                  <div></div>
                  <span className="value d-inline-block">(What customer sees)</span>
              </div>
              <div className="d-flex justify-content-between w-100">
                <span className="fs-6 fw-bold text-center w-100">Bat Product Time</span>
                <div></div>
                <span className="fs-6 fw-bold  text-center w-100">Holiday Time</span>
                <div></div>
                <span className="fs-6 fw-bold  text-center w-100">Delivery Time</span>
                <div></div>
                  <span className="fs-6 fw-bold  text-center w-100">E2E Delivery Time</span>
              </div>
              <div className="d-flex justify-content-around w-100 fw-bold ">
                <span className="w-100 text-center">7 Days</span> 
                <span style={{marginTop:'-20px'}}>+</span> 
                <span className="w-100 text-center">{_holiday.duration==null ?0:_holiday.duration} Days</span> 
                <span style={{marginTop:'-20px'}}>+</span> 
                <span className="w-100 text-center">2 Days</span> 
                <span style={{marginTop:'-20px'}}>=</span> 
                <span className="w-100 text-center">{_holiday.duration==null?9:9+_holiday.duration} Days</span> 
              </div>
            </div>
          </div>
        </div>
        <Tabs defaultIndex={0} className="mt-3 h-100 w-100 overflow-hidden d-sm-none">
          <TabList>
            {categoryList.map((category) => {
                return (
                  <Tab key={category.id}>
                    {category.name}
                  </Tab>
                );
              })}
          </TabList>
          {categoryList.map((category, index) => {
              return (
                <TabPanel index={index} key={category.id}>
                  <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 px-1" style={{marginBottom: "50px"}}>
                    <p style={{marginTop: "80px", marginBottom: "80px"}}>Please select how many days it will take before you dispatch each product.</p>
                    <DispatchTimePicker 
                      days={category.dispatchDays} />
                </div>
                </TabPanel>
              );
            })}
        </Tabs>

        <ul className="category-list d-none d-sm-block" style={{marginTop:'10px'}}> 
          {categoryList.map(category => {
            return (
              <li key={category.id}>
                <h3>{category.name}</h3>
                <DispatchTimePicker days={parseInt("0"+category.dispatchDays)}  />
              </li> 
            )
          })}
        </ul>
        
      </div>
    )
  }


  function AddHolidayDays() {
    const onSubmit = async (e) => {
        setIsLoading(true);
        const data={
          name:e.name,
          duration:e.duration,
          startDate: startDate != null && moment(startDate).format('DD/MM/yyyy'),
        }

        
      const canAdd = canAddHoliday({duration:data.duration, startdate: data.startDate}, holidayDays);
      if (!canAdd) {
        
        toast.error("Cannot add holiday due to overlapping dates with existing holiday, if there are over lapping holiday please use one entry to cover for over lapping holiday.");
        setIsLoading(false);
        setOpen1(false);
        return;
      }

        const res = await apiPost(ADDHOLIDAYDAYS, data );
        if (res) {
            AnalyticsService.logEvent("HOLIDAY_DAYS_ADDED_SUCCESSFULLY");
            toast.success("Holiday days added successfully");
            setOpen1(false);
            await populateHolidayDays();
        }
        setIsLoading(false);
    };
    return (
        <Modal style={{ display: 'none !important',  width: '100%', overflowX: 'auto', overflowY: 'auto'}}
        open={open1} showCloseIcon={true} center onClose={()=>setOpen1(false)}>
            <div className="padding">
                <div className="bold lg space-bottom2">Add New Holiday Days</div>
                    <div>
                    <form onSubmit={handleSubmit(onSubmit)}>

                      <Grid container columnSpacing={2} rowSpacing={2}>

                      <Grid item md={12} xs={12}>
                        <label>Holiday Name</label>
                        <TextField fullWidth size="small" type="text"  {...register("name")}
                          placeholder="Enter Holiday Name"
                          
                          />
                          {errors.name &&  <p className="error">Holiday Name is required</p>}
                      </Grid>
                      

                      
                      
                      <Grid item md={8} xs={12}>
                        <label className='space-top'>Start date</label>
                        <div>
                        <DatePicker
                            placeholderText="Select Start Date"
                            className="datepicker click"
                            onChange={(date) => {
                                
                                setStartDate( date)
                            }}
                            selectsStart
                            withPortal
                            showMonthDropdown
                            // value={startDate != null && moment(startDate).format('DD/MM/yyyy')}
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            disabledKeyboardNavigation={false}
                              onFocus={e => e.target.blur()} 
                              onBeforeInput={(e) => {
                                  e.preventDefault();
                              }}
                            selected={startDate}
                            startDate={startDate}
                        />
                        </div>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <label>Duration</label>
                        <TextField 
                        InputProps={{ 
                          inputProps: { min: 0, max: 100 },
                          endAdornment:(
                            <InputAdornment position="start">
                             <FaCalendar sx={{color: "#8D0C1"}}/>
                             DAYS
                            </InputAdornment>)
                        }}
                           fullWidth size="small" type="number"  {...register("duration")}
                          placeholder="" 
                          />
                        {errors.duration &&  <p className="error">Holiday duration is required</p>}
                      </Grid>

                    
                      </Grid>
                      <div className='push-right space-top'>
                        <Button type="submit" variant="contained" 
                         startIcon={ isLoading? <Spinner
                          size={20}
                          color="red"
                          loading={isLoading}
                          // style={{ marginTop: marginTop }}
                      />:<BiPlus sx={{color:'white'}}/>} >
                            Add Holiday Days
                        </Button>
                      </div>
                      </form>
                    </div>
            </div>

        </Modal>
    )
}

function EditHolidayDays() {
  const update =(key,value)=>{
    set_holiday({..._holiday,[key]:value})
  }

  const onSubmit = async (e) => {
      setIsLoading(true);
      const data ={
        name:_holiday.name,
        duration:_holiday.duration,
        startdate:startDate == null ? moment(_holiday.startDate).format('DD/MM/yyyy'): moment(startDate).format('DD/MM/yyyy'),
        id:_holiday.id
      }

      const updatedHolidayList = holidayDays.filter(holiday => holiday.id !== _holiday.id);
      const canAdd = canAddHoliday(data, updatedHolidayList);
      if (!canAdd) {
        
        toast.error("Cannot update holiday due to over lapping dates with existing holiday, if you have over lapping holidays please create them as one entry.");
        setIsLoading(false);
        setOpen2(false);
        return;
      }

      const res = await apiPost(UPDATEHOLIDAYDAYS, data );

      
      if (res) {
          AnalyticsService.logEvent("HOLIDAY_DAYS_UPDATED_SUCCESSFULLY");
          toast.success("Holiday Days Updated");
          setOpen2(false);
          await populateHolidayDays();
      }else{
        setIsLoading(false);
      }
      setIsLoading(false);
  };
  return (
      <Modal style={{ display: 'none !important',  width: '100%', overflowX: 'auto', overflowY: 'auto'}}
      open={open2} showCloseIcon={true} center onClose={()=>setOpen2(false)}>
          <div className="padding">
              <div className="bold lg space-bottom2">Update Holiday Days</div>
                  <div>
                  <form onSubmit={handleSubmit(onSubmit)}>

                    <Grid container  columnSpacing={2} rowSpacing={2}>

                    <Grid item md={12} xs={12}>
                      <label>Holiday Name</label>
                      <TextField  fullWidth size="small" type="text" value={_holiday?.name} onChange={(e)=>update("name",e.target.value)} 
                        placeholder="Enter Holiday Name" />
                        {errors.name &&  <p className="error">Holiday Name is required</p>}
                    </Grid>

                    <Grid item md={8} xs={12}>
                        <label className='space-top'>Start date</label>
                        <div>
                        <DatePicker
                            placeholderText="Select Start Date"
                            className="datepicker click"
                            onChange={(date) => {
                                setStartDate( date)
                            }}
                            selectsStart
                            withPortal
                            showMonthDropdown
                            value={startDate == null ? moment(_holiday.startDate).format('DD/MM/yyyy'): moment(startDate).format('DD/MM/yyyy')}
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            disabledKeyboardNavigation={false}
                              onFocus={e => e.target.blur()} 
                              onBeforeInput={(e) => {
                                  e.preventDefault();
                              }}
                            selected={startDate}
                            startDate={startDate}
                        />
                        </div>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <label>Duration</label>
                        <TextField 
                        InputProps={{ 
                          inputProps: { min: 0, max: 100 },
                          endAdornment:(
                            <InputAdornment position="start">
                             <FaCalendar sx={{color: "#8D0C1"}}/>
                             DAYS
                            </InputAdornment>)
                        }}
                           fullWidth size="small" type="number" value={_holiday?.duration} onChange={(e)=>update("duration",e.target.value)} 
                          placeholder="" />
                        {errors.duration &&  <p className="error">Holiday duration is required</p>}
                      </Grid>



                  


                    </Grid>
                    <div className='push-right space-top'>
                      <Button
                      startIcon={ isLoading? <Spinner
                        size={20}
                        color="red"
                        loading={isLoading}
                        // style={{ marginTop: marginTop }}
                    />:<FaEdit sx={{color:'white'}}/>} 
                      type="submit" variant="contained" onClick={{onSubmit}}>
                          Update Holiday Days
                      </Button>
                    </div>
                    </form>
                  </div>
          </div>
      </Modal>
  )
}

function DeleteHolidayDays() {

  const onSubmit = async (e) => {
      setIsLoading(true);
      const data ={
        id:_holiday.id
      }
      const res = await apiPost(DELETEHOLIDAYDAYS, data );

      console.log("RES",res)
      if (res) {
          AnalyticsService.logEvent("HOLIDAY_DAYS_DELETED_SUCCESSFULLY");
          toast.success("Holiday deleted successfully");
          setOpen3(false)
          await populateHolidayDays();
      }else{
        setIsLoading(false);
      }
      setIsLoading(false);
  };
  return (
      <Modal style={{ display: 'none !important',  width: '100%', overflowX: 'auto', overflowY: 'auto'}}
      open={open3} showCloseIcon={true} center onClose={()=>setOpen3(false)}>
          <div className="padding">
              <div className="bold lg space-bottom2">Delete Holiday Days</div>
                  <div>
                  <form onSubmit={handleSubmit(onSubmit)} >

                    <Grid container  columnSpacing={2} rowSpacing={2}>

                    <Grid item md={12} xs={12}>
                      <label >Are you sure you want to delete {_holiday.name}</label>
                    </Grid>

                    </Grid>
                    <div className='push-right space-top'>
                      <Stack direction={"row"} spacing={2}>
                      <Button variant="outlined" onClick={()=>setOpen3(false)}>No, Cancel</Button>
                      <Button
                      startIcon={ isLoading? <Spinner
                        size={20}
                        color="red"
                        loading={isLoading}
                        // style={{ marginTop: marginTop }}
                    />:<BiTrash sx={{color:'white'}}/>} 
                      type="submit" variant="contained" onClick={{onSubmit}}>
                          Yes, Delete
                      </Button>

                      </Stack>
                     
                    </div>
                    </form>
                  </div>
          </div>
      </Modal>
  )
}
  

  return (
    <div className="tabPanelCls h-100" >
      <Toaster/>
      <div className="dispatchTimer" style={{position:'relative'}}>
        <div style={{position:'fixed',zIndex:'20',width:'100%',background:'white',marginTop:'0px',marginLeft:'-2px'}}>
        <div className="header">
            <h2 className="ruby center">
              <IconButton onClick={() => handleSettingSwitch("")}>
                <FaBackspace />
              </IconButton>
              Holiday Days
            </h2>
        </div>
        </div>
        
        <div>{view()}</div>
        <div>{details()}</div>

      </div>
    </div>
  )
}

export default HolidayDays;
